<template>
  <el-button
    v-if="reviewStore.squarePaymentLink"
    @click="navToSquare"
    type="success"
    size="large"
    class="max-w-lg mx-auto mt-4"
    plain
  >
    Pay with Square
  </el-button>
</template>

<script setup>
import { useReview } from "@/stores";

const navToSquare = () => {
  window.location.href = reviewStore.squarePaymentLink;
};

const reviewStore = useReview();
</script>
